import ExpandToggler from './components/ExpandToggler';

function init() {
  initToggles();
  initSaveHandlers();

  if (window.jQuery) {
    window.jQuery(document.body).on('updated_cart_totals', initSaveHandlers);
  }
}

function initToggles() {
  ExpandToggler.init({
    parentSelector: '.jp-cart-customization',
    toggleSelector: '.jp-cart-customization__toggle',
    targetSelector: '.jp-cart-customization__panel',
    targetContentSelector: '.jp-cart-customization__panelInner',
    parentExpandedClass: 'jp-cart-customization--open',
    toggleExpandedClass: 'jp-cart-customization__toggle--open',
    expandedClass: 'jp-cart-customization__panel--open'
  });
}

function initSaveHandlers() {
  document.querySelectorAll('.jp-cart-customization__save').forEach(button => {
    if (button.JpCartCustomizationSave) { return; }
    button.JpCartCustomizationSave = true;

    button.addEventListener('click', () => handleSave(button));
  });
}

function getFieldValues(form) {
  const fields = [];

  form.querySelectorAll('.jp-cart-customization__input').forEach(input => {
    const id = input.dataset.fieldId || '';
    if (!id) { return; }

    fields.push({
      id,
      value: input.value
    });
  });

  return fields;
}

function handleSave(button) {
  const form = button.closest('.jp-cart-customization__form');
  if (!form) { return; }

  const cartItemKey = form.dataset.cartItemKey || '';
  const panel = form.closest('.jp-cart-customization');
  const restUrl = panel.dataset.restUrl;
  const restNonce = panel.dataset.restNonce;
  const productId = panel.dataset.productId;
  const fields = getFieldValues(form);

  const postForm = document.createElement('form');
  postForm.method = 'POST';
  postForm.action = restUrl;

  const data = [
    { name: 'cartItemKey', value: cartItemKey },
    { name: 'productId', value: productId }
  ];

  fields.forEach((field, index) => {
    data.push({ name: `fields[${index}][id]`, value: field.id });
    data.push({ name: `fields[${index}][value]`, value: field.value });
  });

  data.push({ name: '_wpnonce', value: restNonce });

  data.forEach(entry => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = entry.name;
    input.value = entry.value;
    postForm.appendChild(input);
  });

  document.body.appendChild(postForm);
  postForm.submit();
}

export default { init };
